import { LanguageCode } from './languages';
import { Translations } from './translations/fr';

// Chaque langue est un chunk séparé, chargé uniquement si elle est choisie (le français est inclus dans le bundle)
export const TRANSLATION_LOADERS: Record<Exclude<LanguageCode, 'fr'>, () => Promise<Translations>> = {
  en: () => import('./translations/en').then(m => m.default),
  es: () => import('./translations/es').then(m => m.default),
  de: () => import('./translations/de').then(m => m.default),
  it: () => import('./translations/it').then(m => m.default),
  pt: () => import('./translations/pt').then(m => m.default),
  nl: () => import('./translations/nl').then(m => m.default),
  pl: () => import('./translations/pl').then(m => m.default),
  ru: () => import('./translations/ru').then(m => m.default),
  tr: () => import('./translations/tr').then(m => m.default),
  ar: () => import('./translations/ar').then(m => m.default),
  zh: () => import('./translations/zh').then(m => m.default),
  ja: () => import('./translations/ja').then(m => m.default),
  ko: () => import('./translations/ko').then(m => m.default),
  hi: () => import('./translations/hi').then(m => m.default),
};
